import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Shield,
  AlertTriangle,
  Activity,
  Globe,
  Server,  
  Lock,
  Eye,
  Filter,
  Settings,
  Database,
  RefreshCw,
  Zap,
  Network, Edit2,
  Wifi, Save, X,
  Clock,
  Terminal,
  Box,
  AlertOctagon,
  FileText,
  ChevronRight,
  Search,
  Bell
} from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import FirewallRules from './FirewallRules'; 
import ThreatWAF from './ThreatWAF';



const NGFWInterface = () => {
  const [activeSection, setActiveSection] = useState('dashboard');
  const [selectedThreat, setSelectedThreat] = useState(null);
  const [dashboardData, setDashboardData] = useState(null);  // Store the fetched data
  const [loading, setLoading] = useState(true);  // Loading state


  return (
    <div className="flex h-screen bg-gray-900 text-gray-300">
            {/* Sidebar */}
            <div className="w-64 bg-gray-800 border-r border-gray-700">
        <div className="p-6">
          <h1 className="text-2xl font-bold text-white">NGFW Control</h1>
          <p className="text-sm text-gray-400 mt-1">Enterprise Security</p>
        </div>

        <nav className="px-4 py-2">
          <ul className="space-y-2">
            {[
              { id: 'dashboard', icon: <Activity size={20} />, label: 'Dashboard' },
              { id: 'firewall', icon: <Shield size={20} />, label: 'Firewall Rules' },
              { id: 'waf', icon: <Globe size={20} />, label: 'WAF Policies', link: '/WAFPolicy' },
              //{ id: 'logs', icon: <Terminal size={20} />, label: 'System Logs' },
              //{ id: 'ids', icon: <Eye size={20} />, label: 'IDS/IPS' },
              //{ id: 'traffic', icon: <Network size={20} />, label: 'Traffic Analysis' },
              //{ id: 'vpn', icon: <Lock size={20} />, label: 'VPN Management' },              
              //{ id: 'reports', icon: <FileText size={20} />, label: 'Reports' },
              //{ id: 'settings', icon: <Settings size={20} />, label: 'Settings' }
            ].map(item => (
              <li key={item.id}>
                {item.link ? ( // Conditional rendering based on the 'link' property
                  <Link
                    to={item.link}
                    className={`w-full flex items-center gap-3 px-4 py-2 rounded-md transition-colors
                      ${activeSection === item.id ? 'bg-blue-600 text-white' : 'hover:bg-gray-700'}`}
                  >
                    {item.icon}
                    <span>{item.label}</span>
                  </Link>
                ) : (
                  <button
                    onClick={() => setActiveSection(item.id)}
                    className={`w-full flex items-center gap-3 px-4 py-2 rounded-md transition-colors
                      ${activeSection === item.id ? 'bg-blue-600 text-white' : 'hover:bg-gray-700'}`}
                  >
                    {item.icon}
                    <span>{item.label}</span>
                  </button>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top navigation */}
        <header className="bg-gray-800 border-b border-gray-700">
          <div className="flex items-center justify-between px-6 py-4">
            <div className="flex items-center gap-4">
              {/*<div className="relative">
                <input
                  type="text"
                  placeholder="Search logs, rules, policies..."
                  className="w-96 bg-gray-700 text-gray-200 pl-10 pr-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <Search size={20} className="absolute left-3 top-2.5 text-gray-400" />
              </div>*/}
              <button className="p-2 hover:bg-gray-700 rounded-md" onClick={() => window.location.reload()}> 
                            <RefreshCw size={20} />
                          </button>
            </div>
            
            <div className="flex items-center gap-4">
              <button className="p-2 hover:bg-gray-700 rounded-md relative">
                <Bell size={20} />
                <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
              </button>
              <div className="h-8 w-px bg-gray-700"></div>
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-400">System Status:</span>
                <span className="text-green-500 flex items-center gap-1">
                  <div className="w-2 h-2 rounded-full bg-green-500"></div>
                  Operational
                </span>
              </div>
            </div>
          </div>
        </header>

          {/* Main content area */}
          <main className="flex-1 overflow-auto p-6">             
              {activeSection === 'firewall' && <FirewallRules />}
              {activeSection === 'dashboard' && <ThreatWAF />}
          </main>
      </div>
    </div>
  );
};

export default NGFWInterface;